import type { BrandAndProductProps } from '../components/ExternalBrandLogo';
import EDITOR_INTEGRATION_MENTIONS from '../editor/mentions/EditorIntegrationMentions';
import getPlatformInfoFromMentionType from './getPlatformInfoFromMentionType';

const getExternalBrandLogoProps = (
  embedOrMentionType: string,
): BrandAndProductProps => {
  const mentionInfo = EDITOR_INTEGRATION_MENTIONS[embedOrMentionType];
  const apiEnum = mentionInfo?.apiEnum;
  const mentionIcon = apiEnum && getPlatformInfoFromMentionType(apiEnum).icon;
  if (mentionIcon) {
    return mentionIcon;
  }
  const [brand, product] = embedOrMentionType.split('-');
  return { brand, product } as BrandAndProductProps;
};

export default getExternalBrandLogoProps;
